import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetch_vendor, fetch_vendors } from './api';
import type { DiscoveryFilters } from './types';

export function use_vendor_discovery(filters: DiscoveryFilters) {
  return useQuery({
    queryKey: ['discovery', filters],
    queryFn: () => fetch_vendors(filters),
    placeholderData: keepPreviousData, // smooth typing/paging
    staleTime: 30 * 1000,
  });
}

export function use_vendor_detail(id: string | undefined, coords?: { lat?: number; lng?: number }) {
  // Both or neither: half a coordinate is a 422, and the key must include them
  // or a cached distance-less response would be reused once location arrives.
  const located = coords?.lat != null && coords?.lng != null ? { lat: coords.lat, lng: coords.lng } : undefined;
  return useQuery({
    queryKey: ['vendor', id, located?.lat ?? null, located?.lng ?? null],
    queryFn: () => fetch_vendor(id as string, located),
    enabled: !!id,
    staleTime: 30 * 1000,
  });
}
